import firebase from "firebase";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCQcTSQ4oYX9IA2iNN9qnGs8GDXBUeaaDs",
  authDomain: "clone-23d21.firebaseapp.com",
  projectId: "clone-23d21",
  storageBucket: "clone-23d21.appspot.com",
  messagingSenderId: "809895909702",
  appId: "1:809895909702:web:65b3b774fbf8b04718ed47",
  measurementId: "G-J95BL17RH2",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();
const auth = firebase.auth();

export { db, auth };
